@if(loaderIcon | async) {<app-loader></app-loader>}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="fw-semibold">Process ACH Payment</h5>
            </div>
            <hr />

            @if (enableACH) {
                <div class="row">
                    <div class="col-12 text-start">
                        <div class="card p-2 mt-2">
                            <div class="row">
                                <div class="col-md-6 col-lg-4 text-left mt-2">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="display" id="rdAutoPayVendrs" value="0" [(ngModel)]="selectedOption" (change)="changeVendorsRadio(0)">
                                        <label class="form-check-label" for="rdAutoPayVendrs">All Autopay Vendors with
                                            Balance due</label>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6 col-lg-4 text-left mt-2">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="chkActiveVendors">
                                        <label class="form-check-label" for="chkActiveVendors">Active Vendors Only</label>
                                    </div>
                                </div> -->
                            </div>
                            <div class="row mt-2 align-items-center">
                                <div class="col-auto">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="display" id="rdAutoPayVendrs" value="1" [(ngModel)]="selectedOption">
                                        <label class="form-check-label" for="rdAutoPayVendrs">{{'Requested Vendor' | wordReplace}}</label>
                                    </div>
                                </div>
                                <div class="col col-lg-2">
                                    <input type="text" class="form-control" id="dealerId" [(ngModel)]="searchVendoralphaNumericID" [disabled]="selectedOption == '0'" (blur)="getVendorById()"/>
                                </div>
                                <div class="col col-lg-3">
                                    <input type="text" class="form-control" [(ngModel)]="searchVendorName" [disabled]="selectedOption == '0'" readonly/>
                                </div>
                                <div class="col-auto">
                                    <button type="button" class="btn btn-sm btn-dark" (click)="OpenVendorSearch(vendorSearchModal)" [disabled]="selectedOption == '0'">
                                        <img src="./assets/images/search.svg" class="img-fluid" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="card p-2 mt-2">

                            <h6 class="mb-2">Payment Processing Progress</h6>

                            <div class="progress mt-2">
                                <div class="progress-bar bg-primary" style="width: 60%;"></div>
                            </div>

                        </div> -->
                        <div class="card p-2 mt-2">
                            <h6 class="fw-bold mb-3">Autopay Vendor with Balance Due</h6>
                            <ejs-grid #gridAch [dataSource]="vendorData" [allowFiltering]="true" (created)='created()' [height]="300" [selectionSettings]="selectionOptions"
                            (rowDataBound)="rowDataBound($event)">
                                <e-columns>
                                    <e-column type="checkbox" textAlign="Center" width="80"></e-column>
                                    <e-column field="MarketVendorId" headerText="Vendor ID" width="100"></e-column>
                                    <e-column field="VendorName" headerText="Vendor Name" width="130"></e-column>

                                    <e-column field="BalanceDue" headerText="Balance Due" width="120" textAlign="Right">
                                        <ng-template #template let-data>
                                            <span>{{data.BalanceDue | currency}}</span>
                                        </ng-template>
                                    </e-column>
                                    <e-column field="PaymentAmount" headerText="Payment Amount" width="150" textAlign="Right" editType="numericedit">
                                        <ng-template #template let-data>
                                            <input class="e-field e-ejinputtext form-control form-control-sm d-inline" style="text-align: center;width:115px;" type='text' maxlength="9"
                                            [(ngModel)]="data.PaymentAmount" [disabled]="isDisablePaymentAmountText(data) || disableACHAfterOneProcess" [appTwoDigitDecimal]='decimalRestrictInput' (change)="changeRecordPaymentAmt($event.target.value, data)">
                                        </ng-template>
                                    </e-column>

                                    <e-column field="ProcessedAmount" headerText="Processed Amount" width="150"
                                        textAlign="Right"></e-column>

                                    <e-column field="PaymentStatus" headerText="Payment Status" width="150"></e-column>
                                    <e-column field="ReceiptId" headerText="Receipt ID" width="150"></e-column>

                                    <e-column headerText="View" field="View" width="90" textAlign="Center">
                                        <ng-template #template let-data>
                                            <img src="./assets/images/view.svg" class="img-fluid" [ariaDisabled]="!data.ReceiptId" (click)="openPreview(data); $event.stopPropagation()"/>
                                        </ng-template>
                                    </e-column>
                                </e-columns>

                                <e-aggregates>
                                    <e-aggregate>
                                        <e-columns>
                                            <e-column field="balanceDue" type="Sum" format="N2">
                                                <ng-template #footerTemplate let-data>
                                                    <span class="text-black"
                                                        style="font-weight: 600; font-size: 14px;">Total: {{ data.Sum
                                                        }}</span>
                                                </ng-template>
                                            </e-column>

                                            <e-column field="paymentAmount" type="Sum" format="N2">
                                                <ng-template #footerTemplate let-data>
                                                    <span class="text-black"
                                                        style="font-weight: 600; font-size: 14px;">Total: {{ data.Sum
                                                        }}</span>
                                                </ng-template>
                                            </e-column>
                                            <e-column field="processedAmount" type="Sum" format="N2">
                                                <ng-template #footerTemplate let-data>
                                                    <span class="text-black"
                                                        style="font-weight: 600; font-size: 14px;">Total: {{ data.Sum
                                                        }}</span>
                                                </ng-template>
                                            </e-column>
                                        </e-columns>
                                    </e-aggregate>
                                </e-aggregates>
                            </ejs-grid>
                        </div>
                        <div class="card p-2 mt-2">
                            <div class="row align-items-center">
                                <div class="col-lg-8 align-items-center flex-wrap gap-4">
                                    <div class="row">
                                        <div class="col-12 d-flex gap-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="printSummary" [(ngModel)]="printautoPaySummary" [disabled]="disableACHAfterOneProcess">
                                                <label class="form-check-label" for="printSummary">
                                                    Print Autopay Summary
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="emailReceipt" [(ngModel)]="emailPaymentReceipt" [disabled]="disableACHAfterOneProcess">
                                                <label class="form-check-label" for="emailReceipt">
                                                    Email Payment Receipt
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 text-end mt-2 mt-lg-0">
                                    <ejs-tooltip id='tooltipbtnautoPay'  target="#btnautoPayACH" position='LeftCenter' (beforeOpen)="onBeforeOpen($event)">
                                        <button class="btn btnAS me-1" id="btnautoPayACH" (click)="validateACHautoPay()" [disabled]="disableAutoPayBtn()" [userPermissionHandler]="createPermissionHandlerData">Auto Pay</button>
                                    </ejs-tooltip>
                                    <button class="btn btn-orange" (click)="clearAutoPay()" >Clear</button>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            } @else {
                <div class="text-center my-5 py-5">
                    <div class="alert alert-info mb-5">
                        ACH is not enabled
                    </div>
                </div>
            }
        </div>
    </div>
</div>
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">New message</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="mb-3">
                        <label for="recipient-name" class="col-form-label">Recipient:</label>
                        <input type="text" class="form-control" id="recipient-name">
                    </div>
                    <div class="mb-3">
                        <label for="message-text" class="col-form-label">Message:</label>
                        <textarea class="form-control" id="message-text"></textarea>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Send message</button>
            </div>
        </div>
    </div>
</div>

 <!-- Modal with Vendor Search Component -->
<div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1" aria-labelledby="vendorSearchLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="vendorSearchLabel">
                    {{'Select Vendor' | wordReplace}}
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption" (vendorSearchRoute)="onVendorSelected($event)">
                </app-vendor-search>
            </div>
        </div>
    </div>
</div>

<!-- Receipt Modal -->
<div class="modal fade" id="printReceiptPopup" tabindex="-1" aria-labelledby="printReceiptModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="printReceiptModalLabel">Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Loading Spinner -->
        <div class="text-center py-5" *ngIf="loading; else pdfViewReceipt">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-muted">Loading receipt...</p>
        </div>

        <!-- PDF View -->
        <ng-template #pdfViewReceipt>
          <iframe *ngIf="receiptUrl" [src]="receiptUrl" width="100%" height="500px" frameborder="0"></iframe>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button class="btn btn-orange" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
